import React, { FC, useMemo } from 'react';
import classNames from 'classnames';
import { MatchHighlight } from 'models/Search';
import { getHasElementsInArray } from 'utils';
import { getOffsetHighlightNodes, getRegexHighlightNodes } from './utils';

import './TextHighlighter.styles.scss';

type TextHighlighterProps = {
  className?: string;
  text: string;
  highlighter?: string | RegExp;
  highlights?: MatchHighlight[];
};

const TextHighlighter: FC<TextHighlighterProps> = ({
  className,
  text,
  highlighter,
  highlights,
}) => {
  const highlightedText = useMemo(() => {
    if (!text) return '';

    if (getHasElementsInArray(highlights))
      return getOffsetHighlightNodes(text, highlights);

    if (!highlighter) return text;

    return getRegexHighlightNodes(text, highlighter);
  }, [highlighter, text, highlights]);

  return (
    <div className={classNames('text-highlighter', className)}>
      {highlightedText}
    </div>
  );
};

export default TextHighlighter;
